import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Group } from '../entities/schema/group.entity';
import { WettbewerberPreisGroup } from '../entities/schema/wettbewerberpreisgroup.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
import { WettbewerberPreis } from '../entities/wettbewerb/wettbewerberpreis.entity';
//#endregion

@Injectable()
export class WettbewerberPreisGroupService extends ODataEntityService<WettbewerberPreisGroup> {
  constructor(protected client: ODataClient) {
    super(client, 'WettbewerberPreisGroup', 'entities.schema.WettbewerberPreisGroup');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public group(entity: EntityKey<WettbewerberPreisGroup>): ODataNavigationPropertyResource<Group> {
    return this.entity(entity).navigationProperty<Group>('group');
  }
  public status(entity: EntityKey<WettbewerberPreisGroup>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<WettbewerberPreisGroup>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  public wettbewerberPreis(entity: EntityKey<WettbewerberPreisGroup>): ODataNavigationPropertyResource<WettbewerberPreis> {
    return this.entity(entity).navigationProperty<WettbewerberPreis>('wettbewerberPreis');
  }
  //#endregion
}
